import { getAuthHeader } from "~/utils/headers";

export const urlMessageBoard = "/api/tracks/message-board";
export const urlMessageBoardTopic = urlMessageBoard + "/topic";
export const urlMessageBoardReply = urlMessageBoardTopic + "/reply";
export const urlMessageBoardToday = urlMessageBoard + "/today ";
export const urlBannerMotw = urlMessageBoard + "/banner/motw";
export const urlBannerPromoTracks = urlMessageBoard + "/banner/promotracks?tracks=3";
export const urlMessageBoardSearch = urlMessageBoard + "/search";
export const urlMessageBoardCommentEdit = urlMessageBoardTopic + "/comment/edit";
export const urlMessageBoardTopicSubjectEdit = urlMessageBoardTopic + "/subject/edit";
export const urlMessageBoardTopicMessageEdit = urlMessageBoardTopic + "/message/edit";
export const urlMessageBoardTopicSetTracker = (threadId, chimDir) => urlMessageBoardTopic + `/${threadId}/tracker/${chimDir}`;
export const urlMessageBoardTopicClearTracker = (threadId, chimDir) => urlMessageBoardTopic + `/${threadId}/clear/tracker/${chimDir}`;

/**
http://www.dreamchimney.com/api/tracks/message-board
http://www.dreamchimney.com/api/tracks/message-board/page/2
http://www.dreamchimney.com/api/tracks/message-board/tracker/ryan/page/1
http://www.dreamchimney.com/api/tracks/message-board/banner/motw
http://www.dreamchimney.com/api/tracks/message-board/random
http://www.dreamchimney.com/api/tracks/message-board/banner/promotracks

/tracks/message-board/topic/subject/edit
/tracks/message-board/topic/message/edit

http://www.dreamchimney.com/api/tracks/message-board/today

http://www.dreamchimney.com/api/tracks/message-board/search?page=1&terms=broker
??
http://www.dreamchimney.com/api/tracks/news

comments
http://www.dreamchimney.com/api/tracks/message-board/topic/21479/replies

search
http://www.dreamchimney.com/api/tracks/message-board/search?page=1&terms=love

pages
http://www.dreamchimney.com/tracks/message-board/today
http://www.dreamchimney.com/tracks/message-board/new

 http://www.dreamchimney.com/api/tracks/message-board/topic/21465
**/

export const getBannerUrl = (axios, type) => {
  if (type === "motw") {
    return axios.get(`${urlBannerMotw}`);
  }
  if (type === "promo") {
    return axios.get(`${urlBannerPromoTracks}`);
  }
};

export const getMessageBoard = (axios, page) => {
  if (page > 1) {
    return axios.get(`${urlMessageBoard}/page/${page}`, getAuthHeader());
  } else {
    return axios.get(`${urlMessageBoard}`, getAuthHeader());
  }
};

export const getMessageBoardToday = (axios) => {
  return axios.get(`${urlMessageBoardToday}`);
};

export const getMessageBoardSearch = (axios, terms, page) => {
  if (page > 1) {
    return axios.get(`${urlMessageBoardSearch}?page=${page}&terms=${terms}`);
  } else {
    return axios.get(`${urlMessageBoardSearch}?terms=${terms}`);
  }
};

export const getMessageBoardTopic = (axios, id) => {
  return axios.get(`${urlMessageBoardTopic}/${id}`);
};

export const getMessageBoardTopicReplies = (axios, id, page) => {
  return axios.get(`${urlMessageBoardTopic}/${id}/replies?page=${page}`);
};

export const postMessageBoardReply = (axios, payload) => axios.post(`${urlMessageBoardReply}`, payload);
export const postMessageBoardCommentEdit = (axios, payload) => axios.post(`${urlMessageBoardCommentEdit}`, payload);

export const postMessageBoardTopicClearTracker = (axios, payload) =>
  axios.post(urlMessageBoardTopicClearTracker(payload.threadId, payload.chimDir));

export const postMessageBoardTopicSubjectEdit = (axios, payload) => axios.post(`${urlMessageBoardTopicSubjectEdit}`, payload);
export const postMessageBoardTopicMessageEdit = (axios, payload) => axios.post(`${urlMessageBoardTopicMessageEdit}`, payload);
